{
  "home": {
    "title": "AquaWorks | Student-led water-quality monitoring",
    "description": "AquaWorks is a student-led engineering project developed by students at the University of British Columbia. The site is located on UBC's Vancouver campus."
  },
  "about": {
    "title": "AquaWorks Phase 1 Project Roadmap",
    "description": "See the AquaWorks Phase 1–3 roadmap: purpose, objectives, robot subsystems, scope limits, and the timeline from build to the January 2027 handoff archive."
  },
  "science": {
    "title": "Water Quality Indicators and Stormwater Context | AquaWorks",
    "description": "Why mobile monitoring matters on the Vancouver campus: stormwater context, five core indicators, and how AquaWorks aligns with the Sustainable Development Goals."
  },
  "team": {
    "title": "Meet the AquaWorks Student Engineering Teams",
    "description": "Meet AquaWorks project leads and four student teams—software, electrical, mechanical, and business—developed by students at the University of British Columbia."
  },
  "updates": {
    "title": "AquaWorks Phase 1 Build Log and Milestones",
    "description": "Follow AquaWorks Phase 1 milestones from project setup through controlled-water validation and the January 2027 handoff archive for future student teams."
  },
  "updateDetail": {
    "title": "{{title}} | AquaWorks Updates",
    "description": "{{summary}}"
  },
  "getInvolved": {
    "title": "Join AquaWorks — student water monitoring team",
    "description": "Join an AquaWorks student sub-team. Students at the University of British Columbia can contact project leads for onboarding, advising, and Phase 1 questions."
  },
  "notFound": {
    "title": "Page not found — 404 | AquaWorks",
    "description": "This AquaWorks page does not exist. Return home or open the project, science, or join pages."
  }
}
